import React from "react";
import "../Profile.scss";
import Button from "../../../../Elements/Button/Button.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "../../../../Elements/Link/Link.js";
import Image from "components/Elements/Image/Image.tsx";

const NoJumboCodes = () => {
  const { getTextByKey } = useContent();

  return (
    <div className="no-codes-to-show">
      <Image className="no-codes-image" name="jumbocode" ext="svg"/>
      <div className="no-codes-section">
        <h2>{getTextByKey("profilecodes-no-codes")}</h2>
        <p>{getTextByKey("profilecodes-sub-info")}</p>
        <LinkToNewTab page={"plans"}>
          <Button buttonClass="purchase-btn">
            {getTextByKey("profilecodes-purchase-btn")}
          </Button>
        </LinkToNewTab>
      </div>
    </div>
  );
};

export default NoJumboCodes;
